<div class="container">
    <div class="header">
        <button mat-icon-button class="close-btn" (click)="closeMenu()">
            <mat-icon>close</mat-icon>
        </button>
        <img class="logo" [src]="logoPath" alt="Logo">
    </div>

    <div class="main">
        <div class="menu-grid">
            <mat-nav-list>
                <ng-container *ngFor="let item of menuItems; let i = index">

                    <a mat-list-item (click)="closeMenu();" [routerLink]="item.routerLink" routerLinkActive="active-link"
                       *ngIf="item.subItems == null && (item.workplaceCategory | findInArray : workplaceConfigNames) && (item.roles | authentication)"
                       [routerLinkActiveOptions]="{exact: true}" [queryParams]="item.queryParams" [skipLocationChange]="item.skipLocationChange"
                       [replaceUrl]="item.replaceUrl"
                       [queryParamsHandling]="item.queryParamsHandling" [preserveFragment]="item.preserveFragment">
                        <mat-icon>{{ item.icon }}</mat-icon>
                        <span>{{ item.label | translate }}</span>
                    </a>

                    <div *ngIf="item.subItems != null" [class.opened]="activeLink == i" [class.active-parent-link]="i | isActiveRoute: menuItems : myRouter.url">
                        <a mat-list-item class="parent-menu-item" (click)="toggleMenuItem(i)" *ngIf="(item.workplaceCategory | findInArray : workplaceConfigNames) && (item.roles | authentication)">
                            <mat-icon>{{ item.icon }}</mat-icon>
                            <span>{{ item.label  | translate }}</span>
                            <mat-icon class="sub-items-toggle" [@subItemOpenClose]="activeLink == i ? 'open' : 'close'">
                                keyboard_arrow_right
                            </mat-icon>
                        </a>
                    </div>
                </ng-container>
            </mat-nav-list>

            <mat-divider [vertical]="true" *ngIf="activeLink == itemIndex" [class.active-divider]="itemIndex | isActiveRoute: menuItems : myRouter.url"></mat-divider>

            <mat-nav-list class="sub-item-list" [@subItem]="activeLink == itemIndex ? 'visibleAnimated' : 'hiddenAnimated'">
                <ng-container *ngFor="let subItem of subItems">
                    <a class="sub-item" (click)="closeMenu()" mat-list-item [routerLink]="subItem.routerLink" [skipLocationChange]="subItem.skipLocationChange"
                       [replaceUrl]="subItem.replaceUrl"
                       [queryParamsHandling]="subItem.queryParamsHandling" [preserveFragment]="subItem.preserveFragment" routerLinkActive="active-sub-link"
                       *ngIf="(subItem.workplaceCategory | findInArray : workplaceConfigNames) && (subItem.roles | authentication)">
                        <mat-icon>{{ subItem.icon }}</mat-icon>
                        <span>{{ subItem.label | translate }}</span>
                    </a>
                </ng-container>
            </mat-nav-list>
        </div>
    </div>

    <div class="side">
        <button mat-icon-button color="primary" (click)="requestFullscreen()">
            <mat-icon>{{ doc.fullscreenElement ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
        </button>
        <button mat-icon-button color="primary" (click)="logout()">
            <mat-icon>exit_to_app</mat-icon>
        </button>
    </div>

    <div class="footer">
        <div class="user-info" *ngIf="username != null">
            <mat-icon>account_circle</mat-icon>
            {{ username }}
        </div>
        <div class="user-info" *ngIf="workplaceConfigNames != null">
            <mat-icon>work</mat-icon>
            {{ workplaceConfigNames }}
        </div>
    </div>
</div>
